import CreateArticleView from "@features/tools/view/article-generator-view/create-article-view";

const CreateArticle = () => {
  return <CreateArticleView />;
};

export default CreateArticle;
